import * as React from 'react';
import { OrderAddressCell, OrderBorrowerCell } from '../components/DataGrid/DataGridOrderFormatters';
import messages from '../utils/messages';
import { BodyText, SmallBodyText } from 'ui-toolkit';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';
import { prettyExternalOrderStatus } from '../../ui-toolkit/enums/eExternalOrderStatus';
import { IPartyData } from '../../ui-toolkit/orders/interfaces/IParty';
import { getBorrowerStringFromParties, ISearchOrderData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrder';
import { DateFormat, getDateString } from '../../ui-toolkit/utilities/getDateString';

export function getOrderColumns(
  userType: eAccessControlUserType,
  onSortChange: (field: string, sort: 'asc' | 'desc') => void
): IBootstrapTableColumnProps<ISearchOrderData>[] {
  const mainColumns: IBootstrapTableColumnProps<ISearchOrderData>[] = [
    {
      dataField: 'fileNumber',
      sort: false,
      text: messages.orders.columns.fileNumber,
    },
    {
      dataField: 'parties',
      formatter: (cell?: any, row?: ISearchOrderData) =>
        (row && <OrderBorrowerCell data={getBorrowerStringFromParties(cell as IPartyData[])} id={row.id} />) || null,
      text: messages.orders.columns.borrowers,
    },
    {
      dataField: 'propertyAddress',
      // Compiler complains about row being {} | undefined so had to change to any for the moment
      formatter: (cell?: any, row?: ISearchOrderData) => (row && <OrderAddressCell data={row} />) || null,
      text: messages.orders.columns.address,
    },
  ];

  const clientAdditionalColumns: IBootstrapTableColumnProps<ISearchOrderData>[] = [
    {
      dataField: 'lenderCompany.name',
      sortFunc: (a, b, sort) => {
        onSortChange('lenderCompany.name', sort);
        return 0;
      },
      sort: true,
      text: messages.orders.columns.lenderName,
    },
  ];

  const endColumns: IBootstrapTableColumnProps<ISearchOrderData>[] = [
    {
      dataField: 'loanNumber',
      text: messages.orders.columns.loanNumber,
    },
    {
      dataField: 'externalPartyTransactionId',
      text: messages.orders.columns.externalPartyTransactionId,
    },
    {
      dataField: 'county',
      text: messages.orders.columns.countyName,
    },
    {
      dataField: 'externalStatus',
      formatter: (cell?: any) => (cell && <BodyText>{prettyExternalOrderStatus[cell]}</BodyText>) || null,
      text: messages.orders.columns.externalStatus,
    },
    {
      dataField: 'closesOn',
      sort: true,
      sortFunc: (a, b, sort) => {
        onSortChange('closesOn', sort);
        return 0;
      },
      formatter: (cell) => <SmallBodyText>{getDateString(DateFormat.short, cell as string)}</SmallBodyText>,
      text: messages.orders.columns.closesOn,
    },
  ];

  return userType === eAccessControlUserType.Client
    ? [...mainColumns, ...clientAdditionalColumns, ...endColumns]
    : [...mainColumns, ...endColumns];
}
